import Collapse from 'emerald-ui/lib/Collapse';
import Panel from 'emerald-ui/lib/Panel';
import populateDocs from './utils/populateDocs';

export default {
  ...populateDocs([{ component: Collapse, componentName: 'Collapse' }], 'Collapse'),
  description: 'Hides or shows content by collapsing or expanding itself.',
  codeSamples: [
    {
      title: 'Default',
      scope: { Panel, Collapse },
      code: `<Collapse expanded={true}>
  <Panel>
    <Panel.Body>
      <h1>This is a panel</h1>
      <p>
        Lorem ipsum dolor sit amet consectetur adipisicing elit.
        Pariatur repudiandae, cum voluptatem vero fugit esse nulla
        dolor! Quis voluptate rerum ipsum fugiat a? Quas, deleniti
        voluptate? Voluptatum facilis aperiam maiores? Lorem ipsum dolor
        sit amet consectetur adipisicing elit. Error ipsam obcaecati
        natus corporis vel ducimus possimus eligendi at rerum magnam!
        Optio officia alias laborum autem. Architecto neque minima sed
        eos?
      </p>
    </Panel.Body>
  </Panel>
</Collapse>`,
    },
  ],
};
